import { Routes } from '@angular/router';

import { TPage } from '@core/enums/page.enum';
import { AuthGuard, authGuard } from '@core/guards/auth.guard';
import { HasTokenParamGuard } from '@core/guards/has-token-param.guard';
import { LoginAsConsumerParamsGuard } from '@core/guards/login-as-consumer-params.guard';
import { LoginAsTenantParamsGuard } from '@core/guards/login-as-tenant-params.guard';
import { nonAuthGuard } from '@core/guards/nonauth.guard';
import { SignalRResolver } from '@core/resolvers/signalr.resolver';
import { tenantThemeResolver } from '@core/resolvers/tenant-theme.resolver';
import { TokenRefreshResolver } from '@core/resolvers/token-refresh.resolver';
import { NotFoundComponent } from '@shared/components/not-found/not-found.component';
import { RedirectComponent } from '@shared/components/redirect/redirect.component';

import { consumerFilesPublicThemeResolver } from '../app/core/resolvers/consumer-files-public-theme.resolver';
import { consumerThemeResolver } from '../app/core/resolvers/consumer-theme.resolver';


export const APP_ROUTES: Routes = [
  { path: '', pathMatch: 'full', component: RedirectComponent },
  {
    path: 'app',
    loadChildren: () => import('./pages/shell-mobile/shell-mobile.routes').then(m => m.SHELL_MOBILE_ROUTES),
    resolve: { tokenRefreshTimeout: TokenRefreshResolver, signalR: SignalRResolver },
    canMatch: [authGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('../../th-common/app/route-modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'log-out',
    loadChildren: () => import('../../th-common/app/route-modules/log-out/log-out.module').then(m => m.LogOutModule),
  },
  {
    path: 'login-as-tenant',
    loadChildren: () =>
      import('../../th-common/app/route-modules/login-as-tenant/login-as-tenant.module').then(
        m => m.LoginAsTenantModule,
      ),
    canActivate: [LoginAsTenantParamsGuard],
  },
  {
    path: 'log-out-as-tenant',
    loadChildren: () =>
      import('../../th-common/app/route-modules/log-out-as-tenant/log-out-as-tenant.module').then(
        m => m.LogOutAsTenantModule,
      ),
  },
  {
    path: 'login-as-consumer',
    loadChildren: () =>
      import('../../th-common/app/shared/modules/login-as-consumer/login-as-consumer.module')
        .then(m => m.LoginAsConsumerModule),
    canMatch: [AuthGuard],
    canActivate: [LoginAsConsumerParamsGuard],
  },
  {
    path: `consumer/${TPage.ClaimFiles}`,
    canActivate: [HasTokenParamGuard],
    resolve: { theme: consumerThemeResolver },
    loadComponent: () =>
      import('./pages/anonymous-files-upload/anonymous-files-upload.component').then(
        m => m.AnonymousFilesUploadComponent,
      ),
  },
  {
    path: `consumer/${TPage.ClaimFilesUpload}`,
    canActivate: [HasTokenParamGuard],
    resolve: { claimTenantInfo: consumerFilesPublicThemeResolver },
    loadComponent: () =>
      import('./pages/anonymous-files-upload-crm/anonymous-files-upload-crm.component').then(
        m => m.AnonymousFilesUploadCrmComponent,
      ),
  },
  {
    path: ':tenant',
    resolve: { theme: tenantThemeResolver },
    loadChildren: () => import('./pages/public/public-mobile.routes').then(m => m.PUBLIC_MOBILE_ROUTES),
    canMatch: [nonAuthGuard],
  },
  { path: '**', component: NotFoundComponent },
];
